export const msalConfig = {
    auth: {
      clientId: "fe449d0d-b5de-4f80-ae23-504f93c8a3a9", // ID de la aplicación registrada para login ad
      authority: "https://login.microsoftonline.com/e3bf4980-93a7-432f-a823-e480938a6143", // Reemplaza TU_TENANT_ID por tu Tenant ID o "common" para múltiples tenants
      redirectUri: "https://analytics.centenario.com.pe/", // URI de redirección configurado en Azure
      postLogoutRedirectUri: "https://analytics.centenario.com.pe/", // Redirección después de cierre de sesión
      //redirectUri: "http://localhost:3000/", // URI de redirección configurado en Azure
      //postLogoutRedirectUri: "http://localhost:3000/", // Redirección después de cierre de sesión
    },
    cache: {
      cacheLocation: "localStorage", // O "localStorage sessionStorage"
      storeAuthStateInCookie: false,
    },
  };
  
  export const loginRequest = {
    scopes: ["User.Read"]
  };
  